module.exports = __webpack_public_path__ + "media/scanner/scan-39f832ef.png";